import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  FormGroup,
  Progress,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";

import axios from "axios";
import { useState, useEffect } from "react";
import { PERANGKAT_DAERAH, API_TIMEOUT } from "utils";
import { toProperCase } from "utils/func";
import { USERS } from "utils";
import FIREBASE from "../config/FIREBASE";
import swal from "sweetalert";
import { logApp } from "utils/func";
import { useHistory } from "react-router-dom";

import { API_SOISALAK } from "../utils";
import { logoutUser } from "actions/AuthAction";

function UsersSoiSalak() {
  const [tabelPerangkatDaerah, setTabelPerangkatDaerah] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [dokumen, setDokumen] = useState("");

  const [status, setStatus] = useState("");
  const [username, setUsername] = useState("");
  const [nama, setNama] = useState("");

  const [url, setUrl] = useState("");
  const [uid, setUid] = useState("");
  const [cari, setCari] = useState(false);
  const [gambar, setGambar] = useState("");
  const [tambah, setTambah] = useState(true);
  const [searchItem, setSearchItem] = useState("");
  const [id_unit, setId_unit] = useState("");
  const [listPd, setListPd] = useState([]);

  const [currentUser, setCurrentUser] = useState("");
  const [accessToken, setAccessToken] = useState("");

  const [listDinas, setListDinas] = useState([]);
  const [listUsers, setListUsers] = useState([]);

  const [profil, setProfil] = useState(null);

  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [userToEdit, setUserToEdit] = useState(null);
  const [statusUser, setStatusUser] = useState(null);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingDinas, setLoadingDinas] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const history = useHistory();

  const onChangeDok = (e) => {
    setDokumen(e.target.files[0]);
  };

  useEffect(() => {
    ambilUsers();
    ambilPerangkatDaerah();
    const userData = localStorage.getItem("user");
    if (!userData) {
      logoutUser(history);
    } else {
      const user = JSON.parse(userData);
      setStatusUser(user.status);
    }
  }, []);

  const handleSimpan = () => {
    if (!nama || !username || !status || !id_unit) {
      swal("Gagal", "Data yang anda masukan harus lengkap", "error");
      return;
    }
    simpanAdmin();
  };

  const simpanAdmin = async () => {
    setLoadingSubmit(true);
    const formData = new FormData();
    formData.append("nama", nama);
    formData.append("idDinas", id_unit);
    formData.append("uidRSS", uid);
    formData.append("status", status);
    formData.append("email", username);
    if (profil) {
      formData.append("profil", gambar);
    }

    try {
      const response = await axios.post(API_SOISALAK + "/users", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 201) {
        swal("Success", "User berhasil ditambahkan", "success");
        ambilUsers();
        onCloseModal();
      } else {
        swal(
          "Failed",
          response.data.message || "Ada kesalahan pada server",
          "error"
        );
      }
    } catch (error) {
      swal(
        "Failed",
        error.response?.data?.message || "Ada kesalahan pada server",
        "error"
      );
    } finally {
      setLoadingSubmit(false);
    }
  };

  const convertGambar = (avatar) => {
    // Data gambar dalam format data URI
    if (avatar) {
      const imageDataURI = avatar; // Sisipkan data gambar lengkap di sini

      // Memisahkan data URI menjadi tipe dan base64 encoded data
      const [dataType, base64Data] = imageDataURI.split(",");

      // Mengubah base64 encoded data menjadi bentuk binary
      const binaryData = atob(base64Data);

      // Mendapatkan panjang data binary
      const len = binaryData.length;

      // Membuat array untuk menyimpan data binary dalam bentuk Uint8Array
      const uint8Array = new Uint8Array(len);

      // Mengisi array dengan data binary
      for (let i = 0; i < len; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      // Membuat file baru dari Uint8Array dan menambahkan tipe datanya
      const file = new File([uint8Array], "gambar.jpg", { type: dataType });

      setGambar(file);
    } else {
      setGambar("");
    }
  };

  const ambilPerangkatDaerah = (id) => {
    setLoadingDinas(true);
    axios({
      method: "get",
      url: API_SOISALAK + "/dinas",
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL
          const data = response.data.data;
          setListDinas(data);
        }
      })
      .catch((error) => {
        // ERROR
        console.error("Error fetching dinas:", error);
      })
      .finally(() => {
        setLoadingDinas(false);
      });
  };

  const ambilUsers = (id) => {
    setLoadingUsers(true);
    axios({
      method: "get",
      url: API_SOISALAK + "/users",
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;

          setListUsers(data);
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      })
      .finally(() => {
        setLoadingUsers(false);
      });
  };

  const getUserEmail = (email) => {
    setLoadingSearch(true);
    FIREBASE.database()
      .ref("users")
      .orderByChild("email")
      .equalTo(email)
      .once("value", (querySnapshot) => {
        //hasil disini

        let data = querySnapshot.val() ? querySnapshot.val() : [];

        let arrayOfNames = [];
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const nama = data[key];
            arrayOfNames.push(nama);
          }
        }

        if (data && arrayOfNames.length > 0 && arrayOfNames[0]) {
          setCari(false);
          setNama(arrayOfNames[0].nama || "");
          setUsername(arrayOfNames[0].email || "");

          //  setDinas(arrayOfNames[0].unitKerja);
          setUrl(arrayOfNames[0].avatar || "");
          setUid(arrayOfNames[0].uid || "");
          convertGambar(arrayOfNames[0].avatar || "");
        } else {
          setCari(false);
          swal("Gagal", "Username tidak ditemukan", "failed");
        }
        setLoadingSearch(false);
      })
      .catch((error) => {
        setCari(false);
        swal("Gagal", "Username tidak ditemukan", "failed");
        setLoadingSearch(false);
      });
  };

  const cariUser = (email) => {
    setCari(true);
    getUserEmail(email);
  };

  const onCloseModal = () => {
    setNama("");
    setUsername("");
    setUid("");
    setUrl("");
    setGambar("");
    setSearchItem("");
    setId_unit("");
    setModalOpen(false);
  };

  const onModalClose2 = () => {
    setNama("");
    setUserIdToDelete(null);
    setModalOpen2(false);
  };

  const handleDelete = async () => {
    if (!userIdToDelete) return;
    setLoadingDelete(true);
    try {
      const response = await axios.delete(
        API_SOISALAK + "/users/" + userIdToDelete
      );
      if (response.status === 200) {
        swal("Sukses", "Data user berhasil dihapus", "success");
        ambilUsers();
        onModalClose2();
      } else {
        swal("Gagal", response.data.message || "Gagal menghapus user", "error");
      }
    } catch (error) {
      swal(
        "Gagal",
        error.response?.data?.message || "Gagal menghapus user",
        "error"
      );
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleEdit = () => {
    if (
      !userToEdit?.nama ||
      !userToEdit?.email ||
      !userToEdit?.status ||
      !userToEdit?.idDinas
    ) {
      swal("Gagal", "Data yang anda masukan harus lengkap", "error");
      return;
    }
    updateUser();
  };

  const updateUser = async () => {
    setLoadingEdit(true);
    const formData = new FormData();
    formData.append("nama", userToEdit.nama);
    formData.append("idDinas", userToEdit.idDinas);
    formData.append("status", userToEdit.status);
    formData.append("email", userToEdit.email);
    formData.append("uidRSS", userToEdit.uidRSS || "");
    if (profil) {
      formData.append("profil", profil);
    }

    try {
      const response = await axios.put(
        API_SOISALAK + "/users/" + userToEdit.id,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        swal("Success", "User berhasil diupdate", "success");
        ambilUsers();
        onCloseEditModal();
      } else {
        swal(
          "Failed",
          response.data.message || "Ada kesalahan pada server",
          "error"
        );
      }
    } catch (error) {
      swal(
        "Failed",
        error.response?.data?.message || "Ada kesalahan pada server",
        "error"
      );
    } finally {
      setLoadingEdit(false);
    }
  };

  const openEditModal = (item) => {
    setUserToEdit({
      id: item.id,
      nama: item.nama,
      email: item.email,
      status: item.status,
      idDinas: item.idDinas,
      uidRSS: item.uidRSS,
      avatar: item.avatar,
    });
    setModalEdit(true);
  };

  const onCloseEditModal = () => {
    setUserToEdit(null);
    setProfil(null);
    setGambar("");
    setModalEdit(false);
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .custom-spinner {
            display: inline-block;
            width: 16px;
            height: 16px;
            border: 2px solid #f3f3f3;
            border-top: 2px solid #007bff;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-right: 8px;
          }
        `}
      </style>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <CardTitle tag="h4">Pengguna SoiSalak</CardTitle>
                {statusUser == 3 && (
                  <Button color="danger" onClick={() => setModalOpen(true)}>
                    Tambah User
                  </Button>
                )}
              </CardHeader>

              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>No</th>
                      <th>Nama</th>
                      <th>Perangkat Daerah</th>
                      <th>Email</th>
                      <th className="text-center">Status</th>
                      {statusUser == 3 && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {loadingUsers ? (
                      <tr>
                        <td
                          colSpan={10}
                          style={{ textAlign: "center", padding: "40px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                border: "4px solid #f3f3f3",
                                borderTop: "4px solid #007bff",
                                borderRadius: "50%",
                                animation: "spin 1s linear infinite",
                              }}
                            />
                            <span style={{ color: "#666", fontSize: "14px" }}>
                              Memuat data pengguna...
                            </span>
                          </div>
                        </td>
                      </tr>
                    ) : listUsers && listUsers.length > 0 ? (
                      listUsers.map((item, index) => (
                        <tr key={item?.id || index}>
                          <td>{index + 1}</td>
                          <td>{item?.nama || "N/A"}</td>
                          <td>{toProperCase(item?.nama_dinas || "N/A")}</td>
                          <td style={{ cursor: "pointer" }}>
                            {item?.email || "N/A"}
                          </td>
                          <td className="text-center" style={{ width: 100 }}>
                            {item?.status == 1
                              ? "admin"
                              : item?.status == 2
                              ? "inputer"
                              : "super admin"}
                          </td>
                          {statusUser == 3 && (
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <Button
                                  size="sm"
                                  color="primary"
                                  style={{ marginRight: 5 }}
                                  onClick={() => openEditModal(item)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  size="sm"
                                  color="danger"
                                  onClick={() => {
                                    setNama(item?.nama || "");
                                    setUserIdToDelete(item?.id);
                                    setModalOpen2(true);
                                  }}
                                >
                                  delete
                                </Button>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10}>Tidak ada data</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          size="md"
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => setModalOpen(false)}>
            <div>
              <div className="headline-2">{"Tambah User"}</div>
            </div>
          </ModalHeader>
          <ModalBody>
            {tambah && (
              <FormGroup>
                <InputGroup>
                  <Input
                    type="text"
                    id="search-input1"
                    value={searchItem}
                    style={{ color: "black" }}
                    onChange={(e) => setSearchItem(e.target.value)}
                  />
                  <InputGroupAddon addonType="append">
                    {loadingSearch ? (
                      <Button color="default" disabled>
                        <div className="custom-spinner" />
                        Loading
                      </Button>
                    ) : (
                      <Button
                        color="default"
                        onClick={() => cariUser(searchItem)}
                      >
                        Search
                      </Button>
                    )}
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            )}
            {url && (
              <Row style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={url ? url : ""}
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: 50,

                    marginBottom: 10,
                    border: "2px solid blue",
                  }}
                />
              </Row>
            )}

            {nama && (
              <div>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Nama
                  </Label>
                  <Col md={9}>
                    <Input
                      type="text"
                      id="default-textarea"
                      placeholder="nama"
                      value={nama}
                      style={{ color: "black" }}
                      onChange={(e) => setNama(e.target.value)}
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Username
                  </Label>
                  <Col md={9}>
                    <Input
                      type="text"
                      id="default-textarea"
                      placeholder="username"
                      style={{ color: "black" }}
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Peran
                  </Label>
                  <Col md={9}>
                    <Input
                      type="select"
                      id="normal-field"
                      style={{ color: "black" }}
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value={""}>- pilih - </option>
                      <option value={1}>admin</option>
                      <option value={2}>inputer </option>
                      <option value={3}>super admin </option>
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Perangkat Daerah
                  </Label>
                  <Col md={9}>
                    <Input
                      type="select"
                      id="normal-field"
                      value={id_unit}
                      style={{ color: "black" }}
                      onChange={(e) => setId_unit(e.target.value)}
                      disabled={loadingDinas}
                    >
                      <option value={""}>
                        {loadingDinas ? "Memuat data dinas..." : "-pilih-"}
                      </option>
                      {!loadingDinas &&
                        listDinas.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.nama_dinas}
                          </option>
                        ))}
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="profil" className="text-md-right">
                    Foto Profil
                  </Label>
                  <Col md={9}>
                    <Input
                      type="file"
                      id="profil"
                      accept="image/*"
                      onChange={(e) => setProfil(e.target.files[0])}
                    />
                  </Col>
                </FormGroup>
              </div>
            )}
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Button
                className="btn-rounded"
                size="sm"
                color="secondary-red"
                onClick={onCloseModal}
              >
                Cancel
              </Button>
              <div style={{ marginLeft: 5 }}></div>
              <Button
                className="btn-rounded"
                color="primary"
                size="sm"
                onClick={() => handleSimpan()}
                disabled={loadingSubmit}
              >
                {loadingSubmit ? (
                  <>
                    <div className="custom-spinner" />
                    Menyimpan...
                  </>
                ) : (
                  "Simpan"
                )}
              </Button>
            </div>
          </ModalFooter>
        </Modal>
        <Modal
          size="md"
          isOpen={modalOpen2}
          toggle={() => onModalClose2()}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => onModalClose2()}>
            <div>
              <div className="headline-2">Konfirmasi hapus akun</div>
            </div>
          </ModalHeader>
          <ModalBody>
            Apakah anda ingin menghapus akun atas nama {nama} ?
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Button
                className="btn-rounded"
                size="sm"
                color="secondary-red"
                onClick={() => onModalClose2()}
              >
                Cancel
              </Button>
              <div style={{ marginLeft: 5 }}></div>
              <Button
                className="btn-rounded"
                color="primary"
                size="sm"
                onClick={handleDelete}
                disabled={loadingDelete}
              >
                {loadingDelete ? (
                  <>
                    <div className="custom-spinner" />
                    Menghapus...
                  </>
                ) : (
                  "Hapus"
                )}
              </Button>
            </div>
          </ModalFooter>
        </Modal>
        <Modal
          size="md"
          isOpen={modalEdit}
          toggle={() => onCloseEditModal()}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => onCloseEditModal()}>
            <div>
              <div className="headline-2">Edit User</div>
            </div>
          </ModalHeader>
          <ModalBody>
            {userToEdit && (
              <div>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Nama
                  </Label>
                  <Col md={9}>
                    <Input
                      type="text"
                      id="default-textarea"
                      placeholder="nama"
                      value={userToEdit.nama}
                      style={{ color: "black" }}
                      onChange={(e) =>
                        setUserToEdit({ ...userToEdit, nama: e.target.value })
                      }
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Email
                  </Label>
                  <Col md={9}>
                    <Input
                      type="text"
                      id="default-textarea"
                      placeholder="email"
                      style={{ color: "black" }}
                      value={userToEdit.email}
                      onChange={(e) =>
                        setUserToEdit({ ...userToEdit, email: e.target.value })
                      }
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Peran
                  </Label>
                  <Col md={9}>
                    <Input
                      type="select"
                      id="normal-field"
                      style={{ color: "black" }}
                      value={userToEdit.status}
                      onChange={(e) =>
                        setUserToEdit({ ...userToEdit, status: e.target.value })
                      }
                    >
                      <option value={""}>- pilih - </option>
                      <option value={1}>admin</option>
                      <option value={2}>inputer </option>
                      <option value={3}>super admin </option>
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="normal-field" className="text-md-right">
                    Perangkat Daerah
                  </Label>
                  <Col md={9}>
                    <Input
                      type="select"
                      id="normal-field"
                      value={userToEdit.idDinas}
                      style={{ color: "black" }}
                      onChange={(e) =>
                        setUserToEdit({
                          ...userToEdit,
                          idDinas: e.target.value,
                        })
                      }
                      disabled={loadingDinas}
                    >
                      <option value={""}>
                        {loadingDinas ? "Memuat data dinas..." : "-pilih-"}
                      </option>
                      {!loadingDinas &&
                        listDinas.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.nama_dinas}
                          </option>
                        ))}
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} for="profil" className="text-md-right">
                    Foto Profil
                  </Label>
                  <Col md={9}>
                    <Input
                      type="file"
                      id="profil"
                      accept="image/*"
                      onChange={(e) => setProfil(e.target.files[0])}
                    />
                  </Col>
                </FormGroup>
              </div>
            )}
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Button
                className="btn-rounded"
                size="sm"
                color="secondary-red"
                onClick={onCloseEditModal}
              >
                Cancel
              </Button>
              <div style={{ marginLeft: 5 }}></div>
              <Button
                className="btn-rounded"
                color="primary"
                size="sm"
                onClick={handleEdit}
                disabled={loadingEdit}
              >
                {loadingEdit ? (
                  <>
                    <div className="custom-spinner" />
                    Menyimpan...
                  </>
                ) : (
                  "Update"
                )}
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default UsersSoiSalak;
